export enum ModuleType {
	czMaxPrice = 'cz-max-price',
	czReimbursement = 'cz-reimbursement',
	skMaxPrice = 'sk-max-price',
	siMaxPrice = 'si-max-price',
	hrMaxPrice = 'hr-max-price',
	bgMaxPrice = 'bg-max-price',
	roMaxPrice = 'ro-max-price',
	roMaxPriceAdditionalPriceRoof = 'ro-max-price-additional-price-roof',
	ltMaxPrice = 'lt-max-price',
}

export default class SystemModule {
	type: ModuleType;

	constructor(type: ModuleType) {
		this.type = type;
	}
}
